export default __webpack_public_path__ + "static/media/4. Hydrogen Lane Factsheet.79a79e7c.pdf";